import { initChatWidget, CHAT_CONFIG } from './chatInit.js'

/**
 * Ouvrir une discussion entre l'Admin Backoffice et un Client
 */
export async function openChatWithClient(client) {
  try {
    await initChatWidget()

    const clientId = client?.id || client?._id
    const clientName = client
      ? `${client.firstName || ''} ${client.lastName || ''}`.trim() || client.name || client.email || 'Client'
      : 'Client'

    // Identifiant Admin unique partagé par tout le Support (ex: 'admin_001')
    const adminId = CHAT_CONFIG.adminUserId

    const conv = await window.XenoTalk.openConversation({
      // Participant 1 : L'Administrateur (utilisateur courant sur le Backoffice)
      participant1Id: adminId,
      participant1Role: 'admin',
      participant1Name: 'Support Client',
      participant1Tag: 'Support Client',
      participant1NotifService: 'rapidoo-admin',

      // Participant 2 : Le Client à contacter (l'interlocuteur)
      participant2Id: clientId,
      participant2Role: 'client',
      participant2Name: clientName,
      participant2Tag: 'Client',
      participant2NotifService: 'rapidoo',

      // Types et Référence (exactement identiques au contrôleur client)
      type: 'support',
      referenceType: 'admin',
      referenceId: `v3-admin-customer-${clientId}`
    })

    window.XenoTalk.setConversation(conv._id, {
      title: clientName,
      tag: 'Client',
      conversation: conv
    })
    window.XenoTalk.openUI()
  } catch (error) {
    console.error('Erreur lors de l\'ouverture du chat avec le client:', error)
  }
}

/**
 * Ouvrir une discussion entre l'Admin Backoffice et un Livreur (Rider)
 */
export async function openChatWithRider(rider) {
  try {
    await initChatWidget()

    const riderId = rider?.userId
    const riderName = rider
      ? `${rider.firstName || ''} ${rider.lastName || ''}`.trim() || rider.name || rider.email || 'Livreur'
      : 'Livreur'

    const adminId = CHAT_CONFIG.adminUserId || 'admin_001'

    const conv = await window.XenoTalk.openConversation({
      // Participant 1 : L'Administrateur
      participant1Id: adminId,
      participant1Role: 'admin',
      participant1Name: 'Support Client',
      participant1Tag: 'Support Client',
      participant1NotifService: 'rapidoo-admin',

      // Participant 2 : Le Livreur
      participant2Id: riderId,
      participant2Role: 'rider',
      participant2Name: riderName,
      participant2Tag: 'Livreur',
      participant2NotifService: 'rapidoo-rider',

      // Types et Référence
      type: 'support',
      referenceType: 'admin',
      referenceId: `v3-admin-rider-${riderId}`
    })

    window.XenoTalk.setConversation(conv._id, {
      title: riderName,
      tag: 'Livreur',
      conversation: conv
    })
    window.XenoTalk.openUI()
  } catch (error) {
    console.error('Erreur lors de l\'ouverture du chat avec le livreur:', error)
  }
}

export function resetChat() {
  if (window.XenoTalk && typeof window.XenoTalk.closeUI === 'function') {
    window.XenoTalk.closeUI()
  }
}